import React from "react";
import PropTypes from "prop-types";

const weekdays = [ "Mon", "Tue", "Wed", "Thu", "Fri" ];

/**
 * Display a table where each row corresponds to a day of the week (Mon..Fri)
 * Takes a single child and clones it for each row, passing props: weekdayName, weekdayIndex
 * @param {Array<String>} [headings] optional list of column headings
 * @param {function} children (weekdayIndex, weekdayName) render callback for each weekday
 */
export default class WeekdayTable extends React.Component {
  
  static propTypes = {
    cssBlockName: PropTypes.string.isRequired,
    header: PropTypes.node,
    children: PropTypes.func.isRequired
  }
  
  render() {
    
    const { header, cssBlockName } = this.props;
    
    return (
      <table className={cssBlockName}>
        { header }
        <tbody>
          { weekdays.map((name, index) => this.props.children(index, name)) }
        </tbody>
      </table>
    )
    
  }
  
}



// WEBPACK FOOTER //
// ./src/components/WeekdayTable.js